import { render, staticRenderFns } from "./MenuNavbar.vue?vue&type=template&id=48079b66&scoped=true"
import script from "./MenuNavbar.vue?vue&type=script&lang=js"
export * from "./MenuNavbar.vue?vue&type=script&lang=js"
import style0 from "./MenuNavbar.vue?vue&type=style&index=0&id=48079b66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48079b66",
  null
  
)

export default component.exports